import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, ToastController, NavParams, AlertController, ViewController} from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';
import { HttpClient} from '@angular/common/http';
import { DataProvider } from '../../providers/data/data';

@IonicPage()
@Component({
  selector: 'page-systemCalendar',
  templateUrl: 'systemCalendar.html',
})
export class SystemCalendarPage {
  private GetOgnoo = [];
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    private data: DataProvider,
    private toastCtrl: ToastController,
    public httpClient: HttpClient,
    private viewCtrl: ViewController,
    ) {

  }

  ionViewDidLoad() {
    document.getElementById('backmenu').style.display = 'block';
    document.getElementById('backFrom').innerText = '';
    this.data.currentTabName = 'Системийн огноо';
    this.date();
  }
  trash (user : any) {
    if(confirm('Та сонгосон огноогоо устгахдаа итгэлтэй байна уу?')){
      this.rest.deleteOgnoo(user.id).subscribe(res => {
        if(res.msg == 'ok') {
          this.showToast('Таны сонгосон огноог амжилттай устгалаа.');
        }
        this.date();
      });
    }
  }
  date(){
    this.rest.GetOgnoo(this.data.companyId).subscribe(res => {
      this.GetOgnoo = res;
    });
  }
  addDays(user: any){
    let addDays = this.modalCtrl.create(
      ModalAddSystemCalendarRequestPage,
      { user: user },
      {
        showBackdrop: false,
        enableBackdropDismiss: true
      }
    );
    addDays.present().catch(err => {

    });
    addDays.onDidDismiss((data) => {
      if(data != null) {
        this.date();
      }
    });
  }
  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}

@Component({
  template: `
  <ion-header text-center style="height: 50px; text-align: center; background-color: #84dac8;">
    <ion-title>Системийн огноо</ion-title>
  </ion-header>
  <ion-content text-center>
    <ion-grid>

      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label floating>Текст</ion-label>
            <ion-textarea [(ngModel)]="val"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>


      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label floating>Жил</ion-label>
            <ion-textarea [(ngModel)]="year"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>


      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label floating>Сар</ion-label>
            <ion-textarea [(ngModel)]="month"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>


      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label floating>Интервал эхлэх огноо</ion-label>
            <ion-textarea [(ngModel)]="bdate"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label floating>Интервал дуусах огноо</ion-label>
            <ion-textarea [(ngModel)]="edate"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-label floating>Интервал хугацаа</ion-label>
          <ion-list  radio-group [(ngModel)]="interval">
            <ion-item>
              <ion-label>15</ion-label>
              <ion-radio value="15" checked="true"></ion-radio>
            </ion-item>
            <ion-item>
              <ion-label>30</ion-label>
              <ion-radio value="30"></ion-radio>
            </ion-item>
          </ion-list>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>
      <br>
      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
          <ion-item>
            <button class="myButton" (click)="addSystemCalendar()" *ngIf="user == null">Нэмэх</button>
            <button class="myButton" (click)="setSystemCalendar()" *ngIf="user !== null">Засах</button>
          </ion-item>
        </ion-col><ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
          <ion-item>
            <button class="myButton" (click)="backto()">Буцах</button>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>
</ion-grid>
</ion-content>
  `
})

export class  ModalAddSystemCalendarRequestPage {
  private addOgnoo:any;
  private editOgnoo:any;
  private year: any;
  private month: any;
  private val: any;
  private bdate: any;
  private edate: any;
  private user: any;
  private ognooId: any;
  private interval = '15';

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    private data: DataProvider,
    public httpClient: HttpClient,
    private toastCtrl: ToastController,
    private viewCtrl: ViewController,)
  {
    this.user = this.navParams.get('user');
        if(this.user != null) {
          this.ognooId = this.user.id;
          this.val = this.user.val;
          this.year = this.user.year;
          this.month = this.user.month;
          this.bdate = this.user.begin_day;
          this.edate = this.user.end_day;
          this.interval = this.user.bminute;
        }
  }
  addSystemCalendar() {
    if( !this.val ){
      this.val == null;
      this.showToast1('Тэкст бичигдээгүй байна!!!');
      return;
    }
    if( !this.year ){
      this.year == null;
      this.showToast1('Жил бичигдээгүй байна!!!');
      return;
    }
    if( !this.month ){
      this.month == null;
      this.showToast1('Сар бичигдээгүй байна!!!');
      return;
    }
    if( !this.bdate ){
      this.bdate == null;
      this.showToast1('Эхлэх өдөр бичигдээгүй байна!!!');
      return;
    }
    if( !this.edate ){
      this.edate == null;
      this.showToast1('Дуусах өдөр бичигдээгүй байна!!!');
      return;
    }
    this.rest.addOgnoo(this.year, this.month, this.val, this.data.companyId, this.bdate, this.edate, this.interval).subscribe(res => {
      this.addOgnoo = res;
      this.showToast('Системийн амжилттай нэмэгдлээ.');
      this.viewCtrl.dismiss({});
    });
  }
  setSystemCalendar() {
    if( !this.val ){
      this.val == null;
      this.showToast1('Тэкст бичигдээгүй байна!!!');
      return;
    }
    if( !this.year ){
      this.year == null;
      this.showToast1('Жил бичигдээгүй байна!!!');
      return;
    }
    if( !this.month ){
      this.month == null;
      this.showToast1('Сар бичигдээгүй байна!!!');
      return;
    }
    if( !this.bdate ){
      this.bdate == null;
      this.showToast1('Эхлэх өдөр бичигдээгүй байна!!!');
      return;
    }
    if( !this.edate ){
      this.edate == null;
      this.showToast1('Дуусах өдөр бичигдээгүй байна!!!');
      return;
    }
    this.rest.editOgnoo(this.year, this.month, this.val, this.ognooId, this.bdate, this.edate, this.interval).subscribe(res => {
      this.editOgnoo = res;
      this.showToast('Системийн амжилттай засагдлаа.');
      this.viewCtrl.dismiss({});
    });
  }
  backto(){
    this.viewCtrl.dismiss({});
  }
  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/systemCalendar/systemCalendar.ts